import clsx from 'clsx';
import { useMemo } from 'react';
import {
  MultiSelectScope,
  SelectionMode,
  useMultiSelectionContext,
} from 'src/contexts/MultiSelectionContext';
import { Checkbox } from 'src/core/interim/Checkbox';
import { vars } from 'src/core/themes';
import { Stack } from 'src/core/ui';
import { ChevronRightIconV2 } from 'src/svgs/Viagogo/goicons/ChevronRightIconV2';
import { Event, Performer, Venue } from 'src/WebApiController';

import {
  EventTileDateCard,
  EventTileInfoHeader,
} from './MobileEventTile.components';
import * as styles from './MobileEventTile.css';

type MobileEventTileProps = {
  event: Event;
  performer?: Performer;
  venue?: Venue;
  selectionMode?: SelectionMode;
  metrics?: React.ReactNode;
  onClick: () => void;
};

export const MobileEventTile = ({
  event,
  venue,
  performer,
  metrics,
  selectionMode,
  onClick,
}: MobileEventTileProps) => {
  const inSelectionMode = useMemo(
    () => selectionMode?.mode === MultiSelectScope.AllGroups,
    [selectionMode?.mode]
  );
  const { toggleGroup, getGroupToggleState } = useMultiSelectionContext();
  const isChecked = useMemo(() => {
    return Boolean(
      event?.virtId && getGroupToggleState(event?.virtId).isGroupSelected
    );
  }, [event?.virtId, getGroupToggleState]);

  return (
    <Stack
      alignItems="center"
      gap="m"
      className={clsx(styles.eventTile, {
        [styles.eventTileSelected]: isChecked,
      })}
      onClick={() => !inSelectionMode && onClick()}
    >
      {inSelectionMode && (
        <Checkbox
          checked={isChecked}
          checkboxSizeVariant="light"
          onChange={() => toggleGroup(event?.virtId)}
        />
      )}
      <EventTileDateCard eventDate={event?.dates?.start} />
      <Stack
        width="full"
        alignItems="start"
        direction="column"
        gap="s"
        className={styles.eventTileContent}
      >
        <EventTileInfoHeader
          event={event}
          venue={venue}
          performer={performer}
        />
        {metrics}
      </Stack>
      {!inSelectionMode && (
        <Stack alignItems="center" height="full">
          <ChevronRightIconV2 size={vars.iconSize.s} />
        </Stack>
      )}
    </Stack>
  );
};
